const prefillFormEmail = {
  init() {
    const $items = $('.js-prefill-form-email');
    if ( $items.length > 0 ) {
      const prefix = 'prefill-form-email'
      $(`#${prefix}-submit`).on('click', function(e){
        e.preventDefault()

        const email = $(`#${prefix}-input`).val()
        if(email == '' || !isValidEmail(email)){
          $('.js-prefill-form-email .mktoError.u-hide').removeClass('u-hide')
        }else{
          $('.js-prefill-form-email .mktoError').addClass('u-hide')
          const formId = $(`.lightbox-content.${prefix}-overlay`).attr('href')
          const emailField = $(formId).find('.mktoEmailField')
          $(`.lightbox-content.${prefix}-overlay`).trigger('click')
          emailField.val(email)
          emailField.parent().addClass('focused')
        }
      });

      if($('.js-form-hanging-label').length > 0){
        const _this = $('.js-form-hanging-label')
        _this.find('form label').on('click', function () {
          const formLabel = $(this)
          formLabel.parent().find('input').focus()
        })
        _this.find('form input').on('input', function () {
          const formInput = $(this)
          if (formInput.val().trim() !== '') {
            formInput.parent().addClass(['focused','typing']);
          }else{
            formInput.parent().removeClass(['focused','typing']);
          }
        });
      }
    }
  },
};
$(prefillFormEmail.init.bind(prefillFormEmail));

function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}
